export const tedeeConfig = {
  common: {
    saving: "Salvando...",
    connected: "Conectado",
    disconnected: "Desconectado",
    lockFallbackNamed: "Fechadura {id}",
    deviceFallbackNamed: "Dispositivo Tedee {id}",
    unitFallback: "Unidade",
    unitFallbackNamed: "Unidade {id}",
  },

  credentials: {
    title: "Configuração do Tedee",
    apiVersionInUse: "Versão da API em uso:",
    savedKey: "Chave salva",
    noKey: "Sem chave",
    keyLabel: "Chave de acesso pessoal",
    keyPlaceholderSaved: "•••••••• (salva, alteração opcional)",
    keyPlaceholderNew: "Insira sua Chave de acesso pessoal do Tedee",
    keyHintSaved: "Você pode deixar em branco se já tiver uma chave salva.",
    keyHintNew: "Obtenha sua chave no portal do Tedee.",
    testing: "Testando...",
    test: "Testar conexão",
    save: "Salvar credenciais",
  },

  selector: {
    title: "Seletor de fechaduras para esta propriedade",
    subA: "Selecione apenas as fechaduras que se aplicam a",
    subBold: "esta propriedade",
    subB: ". Depois você verá apenas as selecionadas no PMS.",
    selectedCount: "{count} selecionadas",
    hintNoKeyA: "Insira sua Chave de acesso pessoal e pressione",
    hintNoKeyBold: "Testar conexão",
    hintNoKeyB: "para carregar suas fechaduras.",
    emptyDevices:
      "Não encontramos nenhuma fechadura ou portão na sua conta Tedee. Verifique se o dispositivo está registrado e compartilhado com a conta cuja chave você salvou acima.",
    placeholder: "Selecionar fechaduras…",
    summaryCount: "{count} fechadura(s) selecionada(s)",
    summaryEmpty: "Nenhuma fechadura selecionada",
    save: "Salvar fechaduras para esta propriedade",
  },

  pms: {
    title: "Controle e atribuição (PMS)",
    subA:
      "Apenas as fechaduras que você salvou para esta propriedade aparecem aqui. Atribua cada uma a",
    subBold1: "Porta principal",
    subOr: "ou",
    subBold2: "Unidade",
    subEnd: ".",
    assignedCount: "{count} atribuídas",
    empty: {
      A: "Você ainda não tem fechaduras salvas para esta propriedade. Use o",
      bold: "seletor",
      B: "acima e depois salve.",
    },
    assignmentLabel: "Atribuição",
    assignmentNone: "Não atribuída",
    assignmentGate: "Porta principal (Portão)",
    assignmentCommon: "Porta principal (compartilhada)",
    assignmentUnit: "Porta do apartamento",
    hintNone: "Não será controlada pelo PMS.",
    hintGate: "Portão: só pode ser acionado para abrir (sem suporte a fechadura/PIN).",
    hintUnit: "Será vinculada a esta propriedade para controle/PINs.",
    unitLabel: "Unidade / Acomodação",
    unitSelect: "Selecione uma unidade",
    unitHint: "Selecione qual unidade esta fechadura abre.",
    nameLabel: "Nome (opcional)",
    namePlaceholder: "Ex.: Porta principal / Apt 101",
    nameHint: "Este nome é salvo quando você salva o seletor de fechaduras novamente.",
    actions: {
      lock: "Trancar",
      unlock: "Destrancar",
      createPin: "Criar PIN",
      pinHistory: "Histórico de PINs",
      openGate: "Abrir portão (pulso)",
      refresh: "Atualizar status",
    },
    save: "Salvar atribuição",
    tipA: "Dica: Atribua uma porta principal ou unidade e pressione",
    tipBold: "Salvar atribuição",
    tipB: ". Os botões são ativados assim que o dispositivo é atribuído.",
  },

  pinHistory: {
    title: "Histórico de PINs",
    loading: "Carregando histórico…",
    empty: "Nenhum PIN registrado para esta fechadura.",
    colAlias: "Apelido",
    colPin: "PIN",
    colValidity: "Validade",
    colState: "Status",
    createdPrefix: "Criado:",
    fromLabel: "De:",
    toLabel: "Até:",
    revokeTitle: "Excluir / Revogar PIN",
    noteA: '* "Ativo" é calculado comparando a data/hora atual com',
    noteMid: "e",
    noteEnd: ".",
    close: "Fechar",
  },

  pinModal: {
    title: "Criar PIN",
    nameLabel: "Nome / Rótulo",
    namePlaceholder: "Ex.: Limpeza / Hóspede / Técnico",
    pinLabel: "PIN",
    pinPlaceholder: "6 dígitos",
    generateTitle: "Gerar",
    pinHint: "Se você deixar em branco, o sistema gera um.",
    modeLabel: "Modo",
    modeTimeLimited: "Com datas",
    modeOngoing: "Sem datas (até ser revogado)",
    validFrom: "Válido de",
    validTo: "Válido até",
    tipLabel: "Dica:",
    tipText: "Para um hóspede, use um PIN com datas de check-in/check-out.",
    cancel: "Cancelar",
    creating: "Criando...",
    create: "Criar PIN",
  },

  toast: {
    noLocksFound: "Nenhuma fechadura (tipo 2/5) encontrada no Tedee.",
    loadStatusError: "Não foi possível carregar o status da fechadura",
    loadStatusError2: "Erro ao carregar o status da fechadura",
    needKey: "Você precisa inserir uma Chave de acesso pessoal ou ter uma chave salva.",
    connectionOk: "Conexão bem-sucedida. {count} dispositivo(s) encontrado(s).",
    testError: "Erro ao testar a conexão",
    needValidKey:
      "Você precisa inserir uma Chave de acesso pessoal válida (pelo menos 10 caracteres).",
    credentialsSaved: "Credenciais salvas com sucesso",
    saveCredentialsError: "Erro ao salvar as credenciais",
    saveCredentialsErrorPrefix: "Erro ao salvar as credenciais: ",
    needOneDevice: "Você precisa selecionar pelo menos um dispositivo para esta propriedade.",
    devicesSaved: "Dispositivos salvos para esta propriedade",
    devicesSaveError: "Não foi possível salvar os dispositivos",
    saveErrorPrefix: "Erro ao salvar: ",
    gateNoLock:
      "O portão (tipo 5) não suporta travamento. Só pode ser acionado para abrir.",
    locked: "Fechadura trancada",
    lockError: "Não foi possível trancar",
    lockError2: "Erro ao trancar",
    gateOpened: "Portão aberto (pulso)",
    unlocked: "Fechadura destrancada",
    unlockError: "Não foi possível destrancar",
    unlockError2: "Erro ao destrancar",
    needUnitForApartment:
      "Selecione a unidade para as fechaduras atribuídas como 'Porta do apartamento'.",
    bindingsSaved: "Atribuição salva com sucesso",
    bindingsSaveError: "Não foi possível salvar a atribuição",
    bindingsSaveErrorPrefix: "Erro ao salvar a atribuição: ",
    gateNoPin: "O portão (tipo 5) não suporta PINs.",
    assignFirst:
      "Primeiro atribua a fechadura (porta principal ou unidade) e salve para habilitar o controle.",
    needPinName: "Você precisa fornecer um nome/rótulo para o PIN.",
    needValidDates: "Você precisa fornecer as datas de válido de e válido até.",
    pinCreated: "PIN criado com sucesso",
    pinCreateError: "Não foi possível criar o PIN",
    pinCreateError2: "Erro ao criar o PIN",
    gateNoPinHistory: "O portão (tipo 5) não suporta histórico de PINs.",
    historyLoadError: "Não foi possível carregar o histórico",
    historyLoadError2: "Erro ao carregar o histórico",
    noProviderPinId:
      "Este PIN não tem provider_pin_id. Não pode ser revogado no Tedee.",
    pinRevoked: "PIN revogado",
    revokeError: "Não foi possível revogar",
    revokeError2: "Erro ao revogar o PIN",
  },

  confirm: {
    revokePin: 'Tem certeza de que deseja revogar/excluir o PIN "{alias}"?',
  },

  pinState: {
    active: "Ativo",
    upcoming: "Agendado",
    expired: "Expirado",
    revoked: "Revogado",
    none: "Sem datas",
  },
};
